import Bugsnag from '@bugsnag/js';

const getApiKey = () => {
  if (process.env.REACT_APP_NODE_ENV === 'development') {
    return process.env.REACT_APP_BUGSNAG_INTEG;
  }
  return process.env.REACT_APP_BUGSNAG_PROD;
};

Bugsnag.start({
  releaseStage: process.env.REACT_APP_NODE_ENV,
  apiKey: getApiKey() || '',
});

const bugsnagHandler = Bugsnag;
export default bugsnagHandler;
